import { getCapacities } from "../../modules/utilities"
import { getNexusCommitteeRowFromCapacity } from "../../components/layout/getNexusCommitteeRowFromCapacity"
import { notEmpty } from "../../modules/utilities"
import { CMTES } from "../../modules/constants"

export const createNexusCommitteesRowData = props => {
  // console.log('createCommitteesRowData props:', props)
  const { connections, isCompany, items, lseCompany, lsePerson, stats } = props
  const rows = []
  var connection = {}

  var committeeStatus = lseCompany
    ? {
      ...getCommitteeStatus(items[0].entity.companyProps.lse.cmtes),
      name: items[0]?.entity?.name.original,
    }
    : null

  items.filter(i => i.level > 0).forEach(item => {
    const showConnection = item.level === 1

    if (showConnection) {

      const indexBit = item.entity.companyProps?.lse?.indexBit

      connection = isCompany
        ? Object.filter(connections, c => c.childId === item.id)
        : Object.filter(connections, c => c.parentId === item.id)

      if (notEmpty(connection)) {
        const capacities = getCapacities(connection, item.id)

        capacities.officer.forEach(role => {

          if (lsePerson) {
            committeeStatus = {
              ...getCommitteeStatus(item.entity.companyProps.lse.cmtes),
              name: item.entity.name.original
            }
          }

          if (role.cmtes !== null) {
            const row = getNexusCommitteeRowFromCapacity({ ...props, committeeStatus, indexBit, role, item })
            rows.push(row)
            ++stats.numRows
            ++stats.numRoles
          }
        })
      }
    }
  })

  return rows
}

// Returns object cmtes with boolean status indicating whether there is or isn't committee
// eg for ALLIANCE WITAN PLC, which has no remuneration committee returns:
// { "aud": true, "rem": false, "nom": true, "name": "ALLIANCE WITAN PLC" }
// ND: (name is added separately)
const getCommitteeStatus = cmtes => (
  {
    [CMTES.AUD]: cmtes[0][0] !== -1,
    [CMTES.REM]: cmtes[1][0] !== -1,
    [CMTES.NOM]: cmtes[2][0] !== -1,
  }
)

